<template>
  <div>
    <input
      :id="inputId"
      type="hidden"
      :name="inputName"
      :value="currentInputValue"
    />

    <div class="input-append">
      <span class="add-on">Quantity</span><input
        v-model="newQuantity"
        class="form-control"
        type="number"
        min="2"
        data-test-selector="new_quantity"
      />
      <span class="add-on">Price</span><input
        v-model="newPrice"
        class="form-control"
        type="text"
        inputmode="decimal"
        data-test-selector="new_price"
      />
      <button class="btn btn-success" @click.prevent="addScalePrice" data-test-selector="add_new_scale_price">
        +
      </button>
    </div>

    <table>
      <tbody>
        <tr>
          <th>Quantity</th>
          <th>Price</th>
          <th>&nbsp;</th>
        </tr>

        <tr v-for="scalePrice in sortedScalePrices" :key="scalePrice.id">
          <td>{{ scalePrice.quantity }}</td>
          <td>{{ scalePrice.price }}</td>
          <td class="action">
            <button class="btn btn-danger" @click.prevent="deleteQuantity(scalePrice.quantity)">
              -
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
    export default {
        props: {
            inputName: null,
            inputId: null,
            inputValue: null,
            i18n: null,
        },
        data() {
            return {
                scalePrices: [],
                newQuantity: '',
                newPrice: '',
                currentId: 0
            };
        },
        computed: {
            sortedScalePrices: function() {
                return this.scalePrices.sort((sp1, sp2) => {
                    let n1 = parseInt(sp1.quantity);
                    let n2 = parseInt(sp2.quantity);
                    if (n1 > n2) return 1;
                    if (n1 < n2) return -1;
                    return 0;
                })
            },
            currentInputValue: function() {
                let simpleDataStructure = this.sortedScalePrices.map((scalePrice) => {
                    return {
                        quantity: scalePrice.quantity,
                        price: scalePrice.price
                    }
                });
                return JSON.stringify(simpleDataStructure);
            },
        },
        mounted() {
            let data = JSON.parse(this.inputValue);
            this.scalePrices = [];
            data.forEach((entry) => {
                this.createEntry(entry.quantity, entry.price);
            })
        },
        methods: {
            addScalePrice: function() {
                if (this.newQuantity>1 && this.newPrice.length>0) {
                    this.deleteQuantity(this.newQuantity);
                    this.createEntry(this.newQuantity, this.newPrice);
                    this.newPrice = '';
                    this.newQuantity = '';
                }
            },
            deleteQuantity: function(quantity) {
                this.scalePrices = this.scalePrices.filter((scalePrice)=> {
                    return scalePrice.quantity !== quantity;
                })
            },
            createEntry: function(quantity, price) {
                this.scalePrices.push({price: price, quantity: quantity, id: this.getNextId()})
            },
            getNextId: function() {
                return this.currentId++;
            }
        }
    };
</script>

<style scoped>
    table {
        min-width: 200px;
        margin-top: 20px;
    }

    th{
        text-align: left;
    }

    td {
        padding: 10px;
    }

    td.action {
        text-align: right;
    }

    input {
        width: 75px;
    }

    @media (prefers-color-scheme: dark) {
        tr:nth-child(even) {
            background-color: #222;
            color: white;
        }
    }


    @media (prefers-color-scheme: light) {
        tr:nth-child(even) {
            background-color: #eee;
            color: black;
        }
    }


    tr:hover {
        background-color: orange;
    }

    .form-control {
        display: inline-block;
        margin: 0 10px;
    }
</style>
